/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Position_Modal_Update_Horizontal_LabelInputs */



/**
* | output |
* | --- |
* | "Update Horizontal" |
*
* @param {Position_Modal_Update_Horizontal_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const position_modal_update_horizontal_label = /** @type {((inputs?: Position_Modal_Update_Horizontal_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Position_Modal_Update_Horizontal_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mettre a jour l'horizontal")
	if (locale === "de") return /** @type {LocalizedString} */ ("Horizontal aktualisieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiorna orizzontale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обновить горизонтальный")
	if (locale === "es") return /** @type {LocalizedString} */ ("Actualización horizontal")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("更新水平")
	if (locale === "ja") return /** @type {LocalizedString} */ ("水平方向の更新")
	if (locale === "hi") return /** @type {LocalizedString} */ ("क्षैतिज अपडेट करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Atualização horizontal")
	return /** @type {LocalizedString} */ ("Update Horizontal")
});